import { render, staticRenderFns } from "./ContactDatagrid.vue?vue&type=template&id=015c93c3&"
import script from "./ContactDatagrid.vue?vue&type=script&lang=js&"
export * from "./ContactDatagrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports